import { Injectable } from '@angular/core';
import { SecureApi } from '../../../core/secure.api';

@Injectable()
export class TokensService {
    constructor(public secureApi: SecureApi) { }

    saveToken(params) {
        return this.secureApi.post('insurance-dashboard/tokens/create', params, false);
    }
}